export default __webpack_public_path__ + "static/media/thanks.f6317091.jpg";